export default "/_resources/app-page/javascript/public/images/report-example-cf7751b20c9bac4b.json"